var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.2242 6.43379C15.5152 6.43379 16.5617 5.38725 16.5617 4.09629C16.5617 2.80532 15.5152 1.75879 14.2242 1.75879C12.9333 1.75879 11.8867 2.80532 11.8867 4.09629C11.8867 5.38725 12.9333 6.43379 14.2242 6.43379Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.87266 11.8879C6.16362 11.8879 7.21016 10.8414 7.21016 9.55039C7.21016 8.25942 6.16362 7.21289 4.87266 7.21289C3.58169 7.21289 2.53516 8.25942 2.53516 9.55039C2.53516 10.8414 3.58169 11.8879 4.87266 11.8879Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2242 17.342C15.5152 17.342 16.5617 16.2955 16.5617 15.0045C16.5617 13.7135 15.5152 12.667 14.2242 12.667C12.9333 12.667 11.8867 13.7135 11.8867 15.0045C11.8867 16.2955 12.9333 17.342 14.2242 17.342Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.89453 10.7266L12.2162 13.8276",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2084 5.27246L6.89453 8.37354",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.3da257c45033dfa1ede5bf3dbb0608b0.svg";
export { ForwardRef as ReactComponent };